import HomeClimateInsiderLogo from './logo'
import {homeClimateInsiderStylesUS} from './styles'

const baseConfig = {
  domainName: 'homeclimateinsider' as const,
  domainType: 'insider' as const,
  siteName: 'Home Climate Insider',
  logo: <HomeClimateInsiderLogo className="size-10 shrink-0 tablet:size-8" />,
  favicon: '/favicons/homeclimateinsider.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-1RR3DZV9EQ',
    camelCaseUrl: 'HomeClimateInsider.com',
    title: (category: string, count: string) =>
      `Home Climate Insider | Top ${count} Pro Insider Choices for ${category}`,
    description: (_category?: string, _count?: string) =>
      `Smart cooling, efficient comfort. AC Home Climate Insider unveils the latest tech in home AC. Discover the best systems for your home.`,
    styles: homeClimateInsiderStylesUS,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
